export enum RequestTypes {
    Http = 0,
    InternalApi = 1,
    KartinaApi = 2,
    ContentApi = 3,
    ODataApi = 4
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/models/request-types.enum.ts